import {MutationTree} from 'vuex';
import {State} from './state';

import {ISearchSettings} from '../models/search-settings-model';
import {SearchResult} from '../models/search-result-model';
import {IDictionary} from '@/shared/models/interface/dictionary-model';
import {IFixedFilter} from '@/shared/models/view/fixed-filter-model';
import {PureSearchService} from "../services/pure/search-service";
import {VUSearchService} from "../services/vu/search-service";
import {IFilterService} from "../services/interfaces/filter-service-interface";
import {IFilterItem} from '../models/filter-item-model';

export default <MutationTree<State>>{
    setConfig(state: State, config: ISearchSettings) {
        state.config = config;
    },

    setSearchService(state: State, service: VUSearchService | PureSearchService) {
        state.searchService = service;
    },

    setFilterService(state: State, service: IFilterService) {
        state.filterService = service;
    },

    setFixedFilters(state: State, filter: IDictionary<IFixedFilter>) {
        state.fixedFilters = filter;
    },

    setUserFilterOverride(state: State, filters: IDictionary<IFilterItem[]>) {
        state.UserFilterOverride = filters;
    },

    setSearchQuery(state: State, query: string) {
        if (query == null) {
            return;
        }

        state.searchQuery = query;
    },

    setIsInitialized(state: State, isInitializing: boolean) {
        state.isInitialized = isInitializing;
    },

    setSearchLoading(state: State, isLoading: boolean) {
        state.searchLoading = isLoading;
    },

    setSearchFailed(state: State, isFailed: boolean) {
        state.searchFailed = isFailed;
    },

    setPageNumber(state: State, number: number) {
        state.pageNumber = number;
    },

    setSearchResultLimit(state: State, limit: number) {
        state.searchResultLimit = limit;
    },

    addSearchResults(state: State, results: SearchResult[]) {
        state.searchResults.push(...results);
    },

    setSearchResults(state: State, results: SearchResult[]) {
        state.searchResults = results;
    },

    setSearchResultsCount(state: State, count: number) {
        state.searchResultsCount = count;
    },

    setImageFallback(state: State, imageFallback: string) {
        state.imageFallback = imageFallback;
    },

    setInitialSearchCallExecuted(state: State, initialSearchCallExecuted: boolean) {
        state.initialSearchCallExecuted = initialSearchCallExecuted;
    }
}